import Vue from 'vue';
import store from './store';
import AuthPopup from "@/components/Auth/AuthPopup";
import PersonalData from "@/components/Personal/PersonalData";
import ReviewForm from "@/components/Reviews/ReviewForm";
import ReviewsList from "@/components/Reviews/ReviewsList";
import ArticlesList from "@/components/Articles/ArticlesList";
import HeaderSearch from "@/components/Search/HeaderSearch";
import CollaborationForm from "@/components/Collaboration/CollaborationForm";
import ConfirmationForm from "@/components/Auth/ConfirmationForm";
import ForgotForm from "@/components/Auth/ForgotForm";
import ProductConfigurator from "@/components/Configurator/ProductConfigurator";
import PageConfiguration from "@/components/Configurator/PageConfiguration";
import ConfiguratorForm from "@/components/Configurator/ConfiguratorForm";
import SearchInput from "@/components/Search/SearchInput";
import SearchResult from "@/components/Search/SearchResult";
import PersonalPassword from "@/components/Personal/PersonalPassword";
import MiniBasket from "@/components/Basket/MiniBasket";
import BasketButtons from "@/components/Basket/BasketButtons";
import BasketDelBtn from "@/components/Basket/BasketDelBtn";
import BigBasket from "@/components/Basket/BigBasket";
import StepsCount from "@/components/Configurator/StepsCount";
import BasketMobile from "@/components/Basket/BasketMobile";
import MiniFavs from "@/components/Favorites/MiniFavs";
import BigFavorites from "@/components/Favorites/BigFavorites";
import ExchangeBtns from "@/components/Exchange/ExchangeBtns";
import CatalogSection from "@/components/Catalog/CatalogSection";
import CatalogItem from "@/components/Catalog/CatalogItem";
import CatalogSort from "@/components/Catalog/CatalogSort";
import CatalogView from "@/components/Catalog/CatalogView";
import CatalogFilter from "@/components/Catalog/CatalogFilter";
import OrderAjax from "@/components/Order/OrderAjax";
import QuickOrderForm from "@/components/Order/QuickOrderForm";
import OrderSuccess from "@/components/Order/OrderSuccess";
import ManagerCallForm from "@/components/Catalog/ProductCard/ManagerCallForm";
import ProductReviewsList from "@/components/Reviews/ProductReviewsList";
import BuyCard from "@/components/Catalog/ProductCard/BuyCard";
import MobileFavorite from "@/components/Catalog/ProductCard/ProductCardMobile/MobileFavorite";
import OfferSelects from "@/components/Catalog/ProductCard/OfferSelects";
import OfferSelectsPallet from "@/components/Catalog/ProductCard/OfferSelectsPallet";
import AnimatedNumber from "@/components/Animation/AnimatedNumber";
import CookiePopup from "@/components/Cookie/CookiePopup";
import ResetConfiguration from "@/components/Configurator/ResetConfiguration";
import DetailOrder from "@/components/Personal/OrdersHistory/DetailOrder";
import DetailOrderPopup  from "@/components/Personal/OrdersHistory/DetailOrderPopup";
import TwoSizesRangeStep   from "@/components/Configurator/TwoSizesRangeStep";
import CatalogProductsList from "./components/Catalog/CatalogProductsList.vue";
import CatalogProduct      from "./components/Catalog/CatalogProduct.vue";

Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;

window.commitData = function(name, value) {
    store.commit(name, value);
};

new Vue({
    el        : "#app",
    data      : () => ({}),
    store,
    components: {
        AuthPopup, PersonalData, ReviewForm, ReviewsList, ArticlesList, HeaderSearch, CollaborationForm,
        ConfirmationForm, ForgotForm, ProductConfigurator, PageConfiguration, ConfiguratorForm, SearchInput,
        SearchResult, PersonalPassword, MiniBasket, BasketButtons, BasketDelBtn, BigBasket, StepsCount,
        BasketMobile, MiniFavs, BigFavorites, ExchangeBtns, CatalogSection, CatalogItem, CatalogSort,
        CatalogView, CatalogFilter, OrderAjax, QuickOrderForm, OrderSuccess, ManagerCallForm, ProductReviewsList,
        BuyCard, MobileFavorite, OfferSelects, OfferSelectsPallet, AnimatedNumber, CookiePopup, ResetConfiguration,
        DetailOrder, DetailOrderPopup, TwoSizesRangeStep, CatalogProductsList, CatalogProduct
    }
});

